import React from 'react';
import { ShieldCheck, Radio, MapPinned, Building2 } from 'lucide-react';
import { FEATURES, STATS } from '../mock';

const ICONS = [Radio, ShieldCheck, MapPinned, Building2];

export default function WhyStats() {
  return (
    <>
      <section id="why" className="py-20 bg-[#f5f7f8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="reveal">
              <img
                src="https://images.unsplash.com/photo-1543499459-d1460946bdc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjb3VyaWVyJTIwZGVsaXZlcnl8ZW58MHx8fHwxNzg5OTE3NTQ3fDA&ixlib=rb-4.1.0&q=85"
                alt="StreetFleet courier handing over a parcel"
                className="rounded-2xl shadow-xl w-full h-[420px] object-cover"
              />
            </div>
            <div>
              <span className="text-[#17A2C4] font-bold uppercase tracking-wider text-sm reveal">Why StreetFleet</span>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-[#4E4E50] mt-2 mb-6 reveal">A courier partner you can count on</h2>
              <div className="grid sm:grid-cols-2 gap-6">
                {FEATURES.map((f, i) => {
                  const Icon = ICONS[i];
                  return (
                    <div key={f.title} className="reveal" data-delay={i * 90}>
                      <div className="w-11 h-11 rounded-lg bg-[#17A2C4]/10 flex items-center justify-center mb-3">
                        <Icon size={22} className="text-[#17A2C4]" />
                      </div>
                      <h3 className="font-extrabold text-[#4E4E50] mb-1">{f.title}</h3>
                      <p className="text-sm text-gray-600">{f.desc}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#17A2C4] py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <div key={s.label} className="text-center text-white reveal" data-delay={i * 80}>
              <div className="text-4xl sm:text-5xl font-extrabold mb-1">{s.value}</div>
              <div className="text-white/80 text-sm font-semibold uppercase tracking-wide">{s.label}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
